import React, { useState, useEffect } from 'react';
import { MDBDataTable } from 'mdbreact';
import { Form, Col, Row } from 'react-bootstrap';
import { Button, Container } from '@mui/material';
import Select from "react-select";
import { Country, State, City } from "country-state-city";
import Swal from 'sweetalert2';
import { RiDeleteBinFill } from "react-icons/ri";
import { FaEdit } from "react-icons/fa";
import "../../assets/css/custom.css";
import { baseURL } from '../base_url';
import axios from 'axios';
import { PuffLoader } from 'react-spinners';
import { FaEye } from "react-icons/fa6";
import moment from 'moment';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import axiosInstance from '../../utils/axiosConfig';

const Location = () => {
  const navigate = useNavigate();
  const [DisplyForm, setDisplyForm] = useState(false)
  const [selectCompany, setSelectCompany] = useState(true)
  const [contactPerson, setContactPerson] = useState('')
  const [locationCode, setLocationCode] = useState('')
  const [locationName, setLocationName] = useState('')
  const [email, setEmail] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [address, setAddress] = useState('')
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [stateData, setStateData] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [city, setCity] = useState("");
  const [zipCode, setZipCode] = useState('')
  const [note, setNote] = useState('')
  const [multiMail, setMultiMail] = useState('')
  const [selectedCompany, setSelectedCompany] = useState('')
  const [companyItems, setCompanyItems] = useState([])
  const [loading, setLoading] = useState(false);
  const [accessDetails, setAccessDetails] = useState([]);
  const [viewEditButton, setViewEditButton] = useState(true)
  const [isActive, setIsActive] = useState(false)
  const [isEdited, setIsEdited] = useState('');
  const [updateFlag, setUpdateFlag] = useState(false);
  const [typeOfUnit, setTypeOfUnit] = useState('')
  const [typeOfgl, setTypeOfgl] = useState('')
  const [errors, setErrors] = useState({
    company: '',
    locationName: '',
    locationCode: '',
    contactPerson: '',
    email: '',
    multiMail: '',
    unitType: '',
    fuelLevelType: '',
    phoneNumber: '',
    zipCode: '',
    address: ''
    // add optional errors as needed
  });

  const loggedInUser = sessionStorage.getItem("tm_token");
  const foundUser = JSON.parse(loggedInUser);
  const authToken = foundUser['auth_token'];

  useEffect(() => {
    axiosInstance.get(baseURL + "/get_company_setup?status=active&admin_id=" + foundUser['tm_id']).then((res) => {
      const menuList = res.data.data.map((val1) => {
        return { label: val1.company_name, value: val1._id }
      })
      setCompanyItems(menuList)
    });
  },[]);

  useEffect(() => {
    setLoading(true);
    axiosInstance.get(baseURL + "/get_location_setup?status=all&admin_id=" + foundUser['tm_id'],
    ).then((res) => {
      var j = 1;
      if(res.data.status === '1'){
        let rowsData = [];
        const myDataSet = res.data.data;
        for (var index = 0; index < res.data.data.length; index++) {
          let rowItem = {};
          const val = myDataSet[index];
          rowItem["id"] = j++;
          rowItem["com_name"] = val.com_name;
          rowItem["l_name"] = val.location_name;
          rowItem["l_code"] = val.location_code;
          rowItem["email"] = val.email;
          rowItem["c_name"] = val.c_name;
          rowItem['c_date'] = moment(new Date(val.created_date)).format('MM/DD/YYYY hh:mm A');
          rowItem['status'] = (val.is_active === 'True' ? 'Active':'In-Active');
          rowItem['action'] = (<React.Fragment><FaEye title='View' onClick={() => vieweditHandle("view-"+val._id)} style={{ marginLeft: '8px', cursor: 'pointer' }}/> {foundUser['tm_accessRole']['Location']['Edit'] == true && (<>|<FaEdit title='Edit' onClick={() => vieweditHandle("edit-"+val._id)} style={{ marginLeft: '8px', cursor: 'pointer' }}/></>)} {foundUser['tm_accessRole']['Location']['Delete'] == true && (<>| <RiDeleteBinFill  title='Delete' onClick={() => deleteHandle(val._id)} style={{ cursor: 'pointer' }}/></>)}</React.Fragment>)
          rowsData.push(rowItem)
        }
        setAccessDetails(rowsData);
      }else{
        setAccessDetails([]);
      }
      setLoading(false);
    })
  },[updateFlag, companyItems]);

  const vieweditHandle = (id) => {
    setLoading(true);
    const explodedArray = id.split('-');
    axiosInstance.post(baseURL + "/get_location_single",{"id":explodedArray[1]}).then((res) => {
      if(res.data.status === '1'){
        // handleCountry(Country.getAllCountries().find(option => option.name === res.data.data.country))
        // setTimeout(() => {
        //   setState(stateData.find(option => option.name === res.data.data.state));
        //   handleState(stateData.find(option => option.name === res.data.data.state))
        //   setTimeout(() => {
        //     setCity(cityData.find(option => option.name === res.data.data.city));
        //   }, 2000);
        // }, 2000);
        setSelectedCompany(companyItems.find(option => parseInt(option.value) === parseInt(res.data.data.company_id)));
        setLocationName(res.data.data.location_name);
        setLocationCode(res.data.data.location_code);
        setContactPerson(res.data.data.contact_person);
        setEmail(res.data.data.email);
        setMultiMail(res.data.data.alert_mails);
        setPhoneNumber(res.data.data.phone_number);
        setTypeOfUnit(unitTypeItems.find(option => option.value === res.data.data.unit_type));
        setTypeOfgl(glTypeItems.find(option => option.value === res.data.data.gl_type));
        setCountry(Country.getAllCountries().find(option => option.name === res.data.data.country));
        setState(State.getAllStates().find(option => option.name === res.data.data.state));
        setCity(City.getAllCities().find(option => option.name === res.data.data.city));
        setAddress(res.data.data.address);
        setZipCode(res.data.data.zipCode);
        setNote(res.data.data.note);
        if (res.data.data.is_active === 'True'){
          setIsActive(true);
        }else{
          setIsActive(false);
        }
        setDisplyForm(true)
        if (explodedArray[0] === 'view'){
          setViewEditButton(false)
        }else{
          setIsEdited(res.data.data._id)
          setViewEditButton(true)
        }
      }else{
        Swal.fire("Something went wrong.")
        return;
      }
      setLoading(false);
    })
  }
  const handleIsActive = (e) => {
    setIsActive(e.target.checked);
  }
  const handleCountry = (value) => {
    const data = State.getAllStates();
    let filteredData = [];
    for (let item of data) {
      if (item?.countryCode === value?.isoCode) filteredData.push(item);
    }
    setStateData(filteredData);
    setState("");

  };
  // const deleteHandle = (id) => {
  //   Swal.fire({
  //     title: 'Are you sure you want to delete?',
  //     showCancelButton: true,
  //     confirmButtonText: 'Yes',
  //   }).then((result) => {
  //     /* Read more about isConfirmed, isDenied below */
  //     if (result.isConfirmed) {
  //       setLoading(true);
  //       axiosInstance.post(baseURL + "/location_delete",
  //         {"id":id,"admin_id":foundUser['tm_id']}).then((res) => {
  //         if(res.data.status === '1'){
  //           Swal.fire('Deleted!', 'Location has been deleted.', 'success')
  //         }else{
  //           Swal.fire("Something went wrong.")
  //         }
  //         setLoading(false);
  //       })
  //       setUpdateFlag(!updateFlag);
  //     }
  //   })
  // }
    const deleteHandle = (id) => {
  Swal.fire({
    title: 'Are you sure you want to delete?',
    showCancelButton: true,
    confirmButtonText: 'Yes',
  }).then((result) => {
    if (result.isConfirmed) {
      setLoading(true);
      axiosInstance.post(baseURL + "/location_delete", {
        "id": id,
        "admin_id": foundUser['tm_id']
      })
      .then((res) => {
        if (res.data.status === '1') {
          Swal.fire('Deleted!', 'Location has been deleted.', 'success');
          setUpdateFlag(!updateFlag);
        } else {
          Swal.fire("Something went wrong.");
        }
      })
      .catch((err) => {
        if (err.response && err.response.status === 429) {
          Swal.fire('Too Many Requests', 
            'You have exceeded the allowed number of delete requests. Please wait and try again.', 
            'warning');
        } else {
          Swal.fire('Oops!', 'Unexpected error occurred.', 'error');
        }
      })
      .finally(() => {
        setLoading(false);
      });
    }
  });
}
  const handleState = (value) => {
    let filteredData = [];
    const data = City.getAllCities();
    for (let item of data) {
      if (
        value?.countryCode === item?.countryCode &&
        value?.isoCode === item?.stateCode
      ) {
        filteredData.push(item);
      }
    }
    setCityData(filteredData);
    setCity("");
  };

  const handleCity = (value) => {
    let filteredData = [];
  }
  
  // useEffect(() => {
  //   const defaultValue = sessionStorage.getItem("selected_company");
  //   if (defaultValue){
  //     setSelectedCompany(options2.find(option => option.value === defaultValue))
  //     setSelectCompany(true)
  //   }
  // },[options2])
  const handleCompanyChange = (selectedOption) => {
    setSelectedCompany(companyItems.find(option => option.value === selectedOption.value))
    setSelectCompany(true)
  }
  
  const handleSubmit = (e) => {
    e.preventDefault();
    setSelectedCompany('');
    setLocationName('');
    setLocationCode('');
    setContactPerson('');
    setEmail('');
    setPhoneNumber('');
    setAddress('');
    setCountry('');
    setState('');
    setCity('');
    setZipCode('');
    setNote('');
    setTypeOfUnit('');
    setTypeOfgl('');
    setMultiMail('');
    setDisplyForm(true)
    setDisplyForm(true)
    setViewEditButton(true);
    setIsEdited('');
  }

  const handleSubmitForm = (e) => {
    e.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if(selectedCompany.toString().trim() === ''){
      Swal.fire({icon: 'error',
                text: 'Please select company name.'})
      return;
    }
    if(locationName.toString().trim() === ''){
      Swal.fire({icon: 'error',
                text: 'Please enter location name.'})
      return;
    }
    if(locationCode.toString().trim() === ''){
      Swal.fire({icon: 'error',
                text: 'Please enter location code.'})
      return;
    }
    if(contactPerson.toString().trim() === ''){
      Swal.fire({icon: 'error',
                text: 'Please enter contact person name.'})
      return;
    }
    if(email.toString().trim() === ''){
      Swal.fire({icon: 'error',
                text: 'Please enter contact person Email-id.'})
      return;
    }
    if (!emailRegex.test(email)){
      Swal.fire({icon: 'error',
                text: 'Please enter contact person valid Email-id.'})
      return;
    }
    if(multiMail.toString().trim() === ''){
      Swal.fire({icon: 'error',
                text: 'Please enter atleast one alert Email-id.'})
      return;
    }

    const payload = {
      'admin_id': foundUser['tm_id'],
      'company_id': selectedCompany.value.toString(),
      'location_name': locationName.toString(),
      'location_code': locationCode.toString(),
      'alert_mails': multiMail.toString(),
      'contact_person': contactPerson.toString(),
      'email':email.toString(),
      'phone_number':phoneNumber?phoneNumber.toString():"",
      'unit_type': typeOfUnit.value.toString(),
      'gl_type': typeOfgl.value.toString(),
      'address':address?address.toString():"",
      'country':country?country.name.toString():"",
      'state':state?state.name.toString():"",
      'city':city?city.name.toString():"",
      'zipCode':zipCode?zipCode.toString():"",
      'note':note?note.toString():"",
      'status': isActive,
      'is_edited': isEdited
    }

    const payloadSize = new Blob([JSON.stringify(payload)]).size;
      if (payloadSize > (1 * 1024 * 1024)) {
        Swal.fire({
          icon: 'error',
          title: 'Payload too large',
          text: 'Your input data exceeds the allowed limit (1 MB). Please shorten some fields.'
        });
        return;
      }

    setLoading(true);
    axiosInstance.post(baseURL + "/create_location", payload).then((res) => {
      setLoading(false);
      if (res.data.status === 'success'){
        setDisplyForm(false)
        let msg = locationName.toString() + " created successfully.";
        Swal.fire({icon: 'success',
          text: msg
        })
      }else if (res.data.status === 'duplicate_name'){
        Swal.fire("<b>"+locationName.toString() + "</b> already exist, Please try with different location name.")
        return;
      }else if (res.data.status === 'duplicate_code'){
        Swal.fire("<b>"+locationCode.toString() + "</b> already exist, Please try with different location code.")
        return;
      }else if (res.data.status === 'updated'){
        setDisplyForm(false)
        let msg = locationName.toString() + " updated successfully.";
        Swal.fire({icon: 'success',
          text: msg
        })
      }else{
        Swal.fire("Something went wrong.")
        return;
      }
      setUpdateFlag(!updateFlag);
    })
    .catch((err) => {
      setLoading(false);
      if (err.response && err.response.status === 429) {
          Swal.fire("Creation limit exceeded. Allow only 3 Location creation per minute");
      }else if (err.response && err.response.status === 413) {
        Swal.fire({
          icon: 'error',
          title: 'Payload Too Large',
          text: 'The data you submitted is too large. Please reduce your input.'
        });
      }else {
          Swal.fire("Something went wrong while creating location.");
      }
      })
  }
  const cancelForm = (e) => {
    e.preventDefault();
    setDisplyForm(false)
    // setSelectCompany(false)
  }
  const unitTypeItems = [
    { label: "Miles", value: "Miles" },
    { label: "Meter", value: "Meter" },
    { label: "Kms", value: "Kms" }
  ];
  const glTypeItems = [
    { label: "Litre", value: "Litre" },
    { label: "Gallon", value: "Gallon" }
  ];
  const handleUnitType = (val) => {
    setTypeOfUnit(unitTypeItems.find(option => option.value === val.value))
  }
  const handleglType = (val) => {
    setTypeOfgl(glTypeItems.find(option => option.value === val.value))
  }
  const data = {
    columns: [
      {
        label: 'S.No',
        field: 'id',
      },
      {
        label: 'Company Name',
        field: 'com_name',
      },
      {
        label: 'Location Name',
        field: 'l_name',
      },
      {
        label: 'Location Code',
        field: 'l_code',
      },
      {
        label: 'Email',
        field: 'email',
      },
      {
        label: 'Created By',
        field: 'c_name',
      },
      {
        label: 'Created DateTime',
        field: 'c_date',
      },
      {
        label: 'Status',
        field: 'status',
      },
      {
        label: 'Action',
        field: 'action',
      },
    ],
    rows: accessDetails
  };
  const searchOptions = {
      text: 'Search by name', // Placeholder text for the search input
      showSearch: true, // Show the search input
      searchLabel: 'Search:', // Label for the search input
    };
      
  return(
      <div className='body_class'>
        {loading ? (
            <div className="loader-overlay">
                <div className="loader">
                <PuffLoader color="#00308F" loading={true} size={200} />
                </div>
            </div>
        ) : ("")}
          <div className='container-fluid'>
            {!DisplyForm  ? (
            <>
            <div className="mt-5">
              {foundUser['tm_accessRole']['Location']['Add'] == true &&
                <Button size="large" type="submit" variant="contained" onClick={handleSubmit}>
                    + Add Location
                </Button>
              }
              <Form.Group as={Row} className="mt-4 d-none" controlId="formPlaintextCountry">
                <Form.Label column sm="2">Company Name *</Form.Label>
                <Col sm="4">
                  <Select placeholder="Select Company" options={companyItems} onChange={handleCompanyChange} value={selectedCompany}/>
                </Col>
              </Form.Group>
            </div>
            </>
            ):""}
            {selectCompany && !DisplyForm  ? (
              <>
              <div className="row mt-1">
                <div className="col-md-12">
                  <MDBDataTable
                    bordered
                    data={data}
                    large={false}
                    displayEntries={false}
                    search={searchOptions}
                    noBottomColumns={true}
                    className="pagination-right-aligned"
                    searching={true}
                  />
                </div>
              </div>
              </>
            ):""}
            
            {DisplyForm ? (
              <>
              <h4>Add Location</h4>
              <div className='mt-4'>
              <div className='container-fluid'>
              {/* <Form onSubmit={handleSubmitForm}>
              <div className='p-3 madatory_fields'>
                <div className="form_section">**Mandatory Fields**</div>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextCN">
                    <Form.Label column sm="2">
                      Company Name *
                    </Form.Label>
                    <Col sm="5">
                      <Select placeholder="Select Company" options={companyItems} onChange={handleCompanyChange} value={selectedCompany}/>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextCP">
                    <Form.Label column sm="2">
                      Location Name *
                    </Form.Label>
                    <Col sm="5">
                      <Form.Control type='text' value={locationName} onChange={(e)=>setLocationName(e.target.value)} placeholder='Location Name' />
                    </Col>
                    <Form.Label column sm="2">
                      Location Code *
                    </Form.Label>
                    <Col sm="3">
                      <Form.Control type='text' value={locationCode} onChange={(e)=>setLocationCode(e.target.value)} placeholder='Location Code' />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextCP">
                    <Form.Label column sm="2">
                      Contact Person *
                    </Form.Label>
                    <Col sm="5">
                      <Form.Control type='text' value={contactPerson} onChange={(e)=>setContactPerson(e.target.value)} placeholder='Contact Person' />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                    <Form.Label column sm="2">
                      Email *
                    </Form.Label>
                    <Col sm="5">
                      <Form.Control type='email' value={email} onChange={(e)=>setEmail(e.target.value)} placeholder='Email'/>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                    <Form.Label column sm="2">
                      Alert Mails *<br/>(Comma Separator)
                    </Form.Label>
                    <Col sm="5">
                      <Form.Control as="textarea" value={multiMail} onChange={(e)=>setMultiMail(e.target.value)} rows={3} placeholder='Note' />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextCP">
                    <Form.Label column sm="2">
                      Unit Type *
                    </Form.Label>
                    <Col sm="4">
                      <Select placeholder="Type Of Unit" options={unitTypeItems} onChange={handleUnitType} value={typeOfUnit} />
                    </Col>
                    <Form.Label column sm="2">
                      Fuel Level Type *
                    </Form.Label>
                    <Col sm="4">
                      <Select placeholder="Type Of Unit" options={glTypeItems} onChange={handleglType} value={typeOfgl} />
                    </Col>
                  </Form.Group>
              </div>
              
              <div className='p-3 madatory_fields'>
                <div className="form_section">**Non Mandatory Fields**</div>
                
                <Form.Group as={Row} className="mb-3" controlId="formPlaintextPN">
                    <Form.Label column sm="2">
                      Phone Number
                    </Form.Label>
                    <Col sm="5">
                      <Form.Control type='text' value={phoneNumber} onChange={(e)=>setPhoneNumber(e.target.value)} placeholder='Phone Number'/>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextAddress">
                    <Form.Label column sm="2">
                      Address
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control type='text' value={address} onChange={(e)=>setAddress(e.target.value)} placeholder='Address' />
                    </Col>
                  </Form.Group>  
                <Form.Group as={Row} className="mb-3" controlId="formPlaintextCountry">
                    <Form.Label column sm="1">
                      Country
                    </Form.Label>
                    <Col sm="2">
                    <Select
                        placeholder={"Country"}
                        options={Country.getAllCountries()}
                        value={country}
                        getOptionLabel={(options) => options.name}
                        getOptionValue={(options) => options.name}
                        onChange={(e) => {
                        setCountry(e);
                        handleCountry(e);
                        }}
                    />
                    </Col>
                    <div className='col-1'></div>
                    <Form.Label column sm="1">
                      State
                    </Form.Label>
                    <Col sm="2">
                    <Select
                        placeholder={"State"}
                        value={state}
                        options={stateData}
                        getOptionLabel={(options) => options.name}
                        getOptionValue={(options) => options.name}
                        onChange={(e) => {
                        setState(e);
                        handleState(e);
                        }}
                    />
                    </Col>
                    <div className='col-1'></div>
                    <Form.Label column sm="1">
                      City
                    </Form.Label>
                    <Col sm="2">
                    <Select
                        placeholder={"City"}
                        value={city}
                        options={cityData}
                        getOptionLabel={(options) => options.name}
                        getOptionValue={(options) => options.name}
                        onChange={(e) => {
                        setCity(e);
                        handleCity(e);
                        }}
                    />
                    </Col>
                  </Form.Group>                
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextZip">
                    <Form.Label column sm="2">
                      Zip Code
                    </Form.Label>
                    <Col sm="5">
                      <Form.Control type='text' value={zipCode} onChange={(e)=>setZipCode(e.target.value)} placeholder='Zip Code' />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextNote">
                    <Form.Label column sm="2">
                      Note
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control as="textarea" value={note} onChange={(e)=>setNote(e.target.value)} rows={3} placeholder='Note' />
                    </Col>
                  </Form.Group>
              </div>
                  <div style={{textAlign:"center"}} className=''>
                  <Form.Group as={Row} className="mt-4" controlId="formPlaintextCheckbox">
                    <Col sm="5"></Col>
                        <Col sm="1">
                        <Form.Check
                            type="checkbox"
                            id="checkbox"
                            label="Is&nbsp;Active"
                            checked={isActive}
                            onChange={handleIsActive}
                        />
                        </Col>
                    </Form.Group>
                    {viewEditButton && 
                      <Button variant="contained" type="submit">
                        Submit
                      </Button>
                    }
                    <Button variant="outlined" type="submit" className="m-4" onClick={cancelForm}>
                      Cancel
                    </Button>
                  </div>
                </Form> */}

              {/* GTIS validation */}
              <Form onSubmit={handleSubmitForm}>
              <div className='p-3 madatory_fields'>
                <div className="form_section">**Mandatory Fields**</div>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextCN">
                    <Form.Label column sm="2">
                      Company Name *
                    </Form.Label>
                    <Col sm="5">
                      {/* <Select placeholder="Select Company" 
                      options={companyItems} 
                      onChange={handleCompanyChange} value={selectedCompany}/> */}
                      <Select
                        placeholder="Select Company"
                        options={companyItems}
                        value={selectedCompany}
                        onChange={(e) => {
                          setSelectedCompany(e);
                          if (!e) {
                            setErrors((prev) => ({ ...prev, company: 'Company is required.' }));
                          } else {
                            setErrors((prev) => ({ ...prev, company: '' }));
                          }
                        }}
                      />
                      {errors.company && <small className="text-danger d-block mt-1">{errors.company}</small>}
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextCP">
                    <Form.Label column sm="2">
                      Location Name *
                    </Form.Label>
                    <Col sm="5">
                      {/* <Form.Control type='text' value={locationName} onChange={(e)=>setLocationName(e.target.value)} placeholder='Location Name' /> */}
                      <Form.Control
                        type='text'
                        value={locationName}
                        maxLength={51}
                        placeholder='Location Name'
                        onChange={(e) => {
                          const rawValue = e.target.value;
                          if(rawValue.length >= 50){
                            setErrors((prev) => ({...prev, locationName: 'Location Name cannot exceeds 50 characters'}))
                            return;
                          }
                          // Remove all numbers and special chars
                          const cleanedValue = rawValue.replace(/[^A-Za-z ]/g, '');
                          setLocationName(cleanedValue);


                          if (rawValue !== cleanedValue) {
                            setErrors((prev) => ({ ...prev, locationName: 'Only alphabets and spaces are allowed in the location name.' }));
                          } else if (cleanedValue.trim() === '') {
                            setErrors((prev) => ({ ...prev, locationName: 'Location name is required.' }));
                          } else if (cleanedValue.trim().length < 3) {
                            setErrors((prev) => ({ ...prev, locationName: 'Location name must be at least 3 characters long.' }));
                          } else {
                            setErrors((prev) => ({ ...prev, locationName: '' }));
                          }
                        }}
                      />

                      {errors.locationName && <small className="text-danger d-block mt-1">{errors.locationName}</small>}

                    </Col>
                    <Form.Label column sm="2">
                      Location Code *
                    </Form.Label>
                    <Col sm="3">
                      {/* <Form.Control type='text' value={locationCode} onChange={(e)=>setLocationCode(e.target.value)} placeholder='Location Code' /> */}
                      <Form.Control
                        type='text'
                        value={locationCode}
                        maxLength={16}
                        placeholder='Location Code'
                        onChange={(e) => {
                          if(e.target.value.length >= 16){
                            setErrors((prev) => ({...prev, locationCode: 'Location code cannot exceeds 15 characters'}))
                            return;
                          }
                          const val = e.target.value.replace(/[^A-Za-z0-9]/g, '');
                          setLocationCode(val);
                          if (val.trim() === '') {
                            setErrors((prev) => ({ ...prev, locationCode: 'Location code is required.' }));
                          } else {
                            setErrors((prev) => ({ ...prev, locationCode: '' }));
                          }
                        }}
                      />
                      {errors.locationCode && <small className="text-danger d-block mt-1">{errors.locationCode}</small>}

                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextCP">
                    <Form.Label column sm="2">
                      Contact Person *
                    </Form.Label>
                    <Col sm="5">
                      {/* <Form.Control type='text' value={contactPerson} onChange={(e)=>setContactPerson(e.target.value)} placeholder='Contact Person' /> */}
                      <Form.Control
                          type='text'
                          value={contactPerson}
                          maxLength={51}
                          placeholder='Contact Person'
                          onChange={(e) => {
                            const raw = e.target.value;
                            if(raw.length >=51){
                              setErrors((prev) => ({...prev, contactPerson: 'Contact Person name cannot exceeds 50 characters'}))
                              return;
                            }
                            if (/[^A-Za-z ]/.test(raw)) {
                              setErrors((prev) => ({ ...prev, contactPerson: 'Characters & spaces only.' }));
                              return;
                            }
                            setContactPerson(raw);
                            if (raw.trim() === '') {
                              setErrors((prev) => ({ ...prev, contactPerson: 'Contact Person is required.' }));
                            } else if (raw.trim().length < 3) {
                              setErrors((prev) => ({ ...prev, contactPerson: 'At least 3 characters.' }));
                            } else {
                              setErrors((prev) => ({ ...prev, contactPerson: '' }));
                            }
                          }}
                        />
                        {errors.contactPerson && <small className="text-danger d-block mt-1">{errors.contactPerson}</small>}

                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                    <Form.Label column sm="2">
                      Email *
                    </Form.Label>
                    <Col sm="5">
                      {/* <Form.Control type='email' value={email} onChange={(e)=>setEmail(e.target.value)} placeholder='Email'/> */}
                      <Form.Control
                        type='email'
                        value={email}
                        placeholder='Email'
                        maxLength={51}
                        onChange={(e) => {
                          const val = e.target.value;
                          if(val.length >= 50){
                            setErrors((prev) => ({...prev, email: 'Email cannot exceeds 50 characters'}))
                            return;
                          }
                          setEmail(val);
                          if (val.trim() === '') {
                            setErrors((prev) => ({ ...prev, email: 'Email is required.' }));
                          } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
                            setErrors((prev) => ({ ...prev, email: 'Please enter a valid email.' }));
                          } else {
                            setErrors((prev) => ({ ...prev, email: '' }));
                          }
                        }}
                      />
                      {errors.email && <small className="text-danger d-block mt-1">{errors.email}</small>}

                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                    <Form.Label column sm="2">
                      Alert Mails *<br/>(Comma Separator)
                    </Form.Label>
                    <Col sm="5">
                      {/* <Form.Control as="textarea" value={multiMail} onChange={(e)=>setMultiMail(e.target.value)} rows={3} placeholder='Note' /> */}
                      <Form.Control
                          as="textarea"
                          value={multiMail}
                          placeholder='e.g. mail1@example.com, mail2@example.com'
                          onChange={(e) => {
                            const val = e.target.value;
                            setMultiMail(val);

                            // Check empty first
                            if (val.trim() === '') {
                              setErrors((prev) => ({ ...prev, multiMail: 'Alert Mails is required.' }));
                            } else {
                              // Split by comma, trim whitespace
                              const emails = val.split(',').map(email => email.trim()).filter(email => email !== '');
                              // Regex for email validation
                              const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                              // Check if every email passes validation
                              const allValid = emails.every(email => emailRegex.test(email));
                              if (!allValid) {
                                setErrors((prev) => ({ ...prev, multiMail: 'Please enter valid emails, separated by commas.' }));
                              } else {
                                setErrors((prev) => ({ ...prev, multiMail: '' }));
                              }
                            }
                          }}
                        />
                      {errors.multiMail && <small className="text-danger d-block mt-1">{errors.multiMail}</small>}
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextCP">
                    <Form.Label column sm="2">
                      Unit Type *
                    </Form.Label>
                    <Col sm="4">
                      {/* <Select placeholder="Type Of Unit" options={unitTypeItems} onChange={handleUnitType} value={typeOfUnit} /> */}
                      <Select
                        placeholder="Type Of Unit"
                        options={unitTypeItems}
                        onChange={(e) => {
                          setTypeOfUnit(e); // Save the value
                          if (!e) {
                            setErrors((prev) => ({ ...prev, unitType: 'Unit Type is required.' }));
                          } else {
                            setErrors((prev) => ({ ...prev, unitType: '' }));
                          }
                        }}
                        value={typeOfUnit}
                      />
                      {errors.unitType && <small className="text-danger d-block mt-1">{errors.unitType}</small>}

                    </Col>
                    <Form.Label column sm="2">
                      Fuel Level Type *
                    </Form.Label>
                    <Col sm="4">
                      {/* <Select placeholder="Type Of Unit" options={glTypeItems} onChange={handleglType} value={typeOfgl} /> */}
                      <Select
                        placeholder="Fuel Level Type"
                        options={glTypeItems}
                        onChange={(e) => {
                          setTypeOfgl(e); // Save the value
                          if (!e) {
                            setErrors((prev) => ({ ...prev, glType: 'Fuel Level Type is required.' }));
                          } else {
                            setErrors((prev) => ({ ...prev, glType: '' }));
                          }
                        }}
                        value={typeOfgl}
                      />
                      {errors.glType && <small className="text-danger d-block mt-1">{errors.glType}</small>}
                    </Col>
                  </Form.Group>
              </div>
              
              <div className='p-3 madatory_fields'>
                <div className="form_section">**Non Mandatory Fields**</div>
                
                <Form.Group as={Row} className="mb-3" controlId="formPlaintextPN">
                    <Form.Label column sm="2">
                      Phone Number
                    </Form.Label>
                    <Col sm="5">
                      {/* <Form.Control type='text' value={phoneNumber} onChange={(e)=>setPhoneNumber(e.target.value)} placeholder='Phone Number'/> */}
                      <Form.Control
                        type='text'
                        value={phoneNumber}
                        placeholder='Phone Number'
                        maxLength={16}
                        onChange={(e) => {
                          const val = e.target.value.replace(/\D+/g, '');
                          if(val.length >= 15){
                            setErrors((prev) => ({...prev, phoneNumber: 'Phone number cannot exceeds 15 digits'}))
                            return;
                          }
                          setPhoneNumber(val);
                          if (/[^0-9]/.test(val)) {
                              setErrors((prev) => ({ ...prev, phoneNumber: 'Numbers only allowed' }));
                              return;
                            }
                          if (val && !/^\d{7,15}$/.test(val)) {
                            setErrors((prev) => ({ ...prev, phoneNumber: 'Phone must be 7-15 digits.' }));
                          } else {
                            setErrors((prev) => ({ ...prev, phoneNumber: '' }));
                          }
                        }}
                      />
                      {errors.phoneNumber && <small className="text-danger d-block mt-1">{errors.phoneNumber}</small>}

                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextAddress">
                    <Form.Label column sm="2">
                      Address
                    </Form.Label>
                      <Col sm="8">
                        <Form.Control 
                          type='text' 
                          value={address}
                          placeholder='Address'
                          onChange={(e) => {
                            const rawVal = e.target.value;
                            const cleanedVal = rawVal.replace(/[^A-Za-z0-9\s,./-]/g, '');

                            let finalVal = cleanedVal;
                            let errorMsg = '';

                            if (rawVal.length > 150) {
                              finalVal = cleanedVal.slice(0, 150);
                              errorMsg = 'Address cannot exceed 150 characters.';
                            } else if (finalVal.trim().length < 5) {
                              errorMsg = 'Address must be at least 5 characters.';
                            }

                            setAddress(finalVal);
                            setErrors(prev => ({ ...prev, address: errorMsg }));
                          }}
                        />
                        {errors.address && <small className="text-danger d-block mt-1">{errors.address}</small>}

                    </Col>
                  </Form.Group>  
                <Form.Group as={Row} className="mb-3" controlId="formPlaintextCountry">
                    <Form.Label column sm="1">
                      Country
                    </Form.Label>
                    <Col sm="2">
                    <Select
                        placeholder={"Country"}
                        options={Country.getAllCountries()}
                        value={country}
                        getOptionLabel={(options) => options.name}
                        getOptionValue={(options) => options.name}
                        onChange={(e) => {
                        setCountry(e);
                        handleCountry(e);
                        }}
                    />
                    </Col>
                    <div className='col-1'></div>
                    <Form.Label column sm="1">
                      State
                    </Form.Label>
                    <Col sm="2">
                    <Select
                        placeholder={"State"}
                        value={state}
                        options={stateData}
                        getOptionLabel={(options) => options.name}
                        getOptionValue={(options) => options.name}
                        onChange={(e) => {
                        setState(e);
                        handleState(e);
                        }}
                    />
                    </Col>
                    <div className='col-1'></div>
                    <Form.Label column sm="1">
                      City
                    </Form.Label>
                    <Col sm="2">
                    <Select
                        placeholder={"City"}
                        value={city}
                        options={cityData}
                        getOptionLabel={(options) => options.name}
                        getOptionValue={(options) => options.name}
                        onChange={(e) => {
                        setCity(e);
                        handleCity(e);
                        }}
                    />
                    </Col>
                  </Form.Group>                
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextZip">
                    <Form.Label column sm="2">
                      Zip Code
                    </Form.Label>
                    <Col sm="5">
                      <Form.Control
                        type='text'
                        value={zipCode}
                        placeholder='Zip Code'
                        onChange={(e) => {
                          const rawVal = e.target.value;

                          // Keep only letters and digits
                          const cleanedVal = rawVal.replace(/[^A-Za-z0-9]/g, '');

                          // Hard limit: slice to 10
                          const finalVal = cleanedVal.slice(0, 10);

                          setZipCode(finalVal);

                          // Validation: check what user tried
                          if (cleanedVal.trim() === '') {
                            setErrors(prev => ({ ...prev, zipCode: 'Zip code is required.' }));
                          } else if (cleanedVal.length < 3) {
                            setErrors(prev => ({ ...prev, zipCode: 'Zip code must be at least 3 characters.' }));
                          } else if (rawVal.length > 10) {
                            setErrors(prev => ({ ...prev, zipCode: 'Zip code cannot exceed 10 characters.' }));
                          } else {
                            setErrors(prev => ({ ...prev, zipCode: '' }));
                          }
                        }}
                      />
                        {errors.zipCode && <small className="text-danger d-block mt-1">{errors.zipCode}</small>}
                      </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextNote">
                    <Form.Label column sm="2">
                      Note
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control as="textarea" value={note} onChange={(e)=>setNote(e.target.value)} rows={3} placeholder='Note' />
                    </Col>
                  </Form.Group>
              </div>
                  <div style={{textAlign:"center"}} className=''>
                  <Form.Group as={Row} className="mt-4" controlId="formPlaintextCheckbox">
                    <Col sm="5"></Col>
                        <Col sm="1">
                        <Form.Check
                            type="checkbox"
                            id="checkbox"
                            label="Is&nbsp;Active"
                            checked={isActive}
                            onChange={handleIsActive}
                        />
                        </Col>
                    </Form.Group>
                    {viewEditButton && 
                      <Button variant="contained" type="submit">
                        Submit
                      </Button>
                    }
                    <Button variant="outlined" type="submit" className="m-4" onClick={cancelForm}>
                      Cancel
                    </Button>
                  </div>
                </Form>
              </div>
              </div>
              </>
            ):""}
          </div>
      </div>
    )
}

export default Location;